module.exports = __webpack_public_path__ + "img/antes_despues_82.32ee26c7.png";